import { aboutNavTitle, featuresNavTitle, topicsNavTitle, cardsNavTitle, carouselNavTitle } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200 border-t border-background-300/50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">爱看影院</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              爱看影院提供海量高清电影和高清电视剧在线观看服务，高清画质不缓冲秒播，最新热播剧集每日更新，免费高清影院等你来追剧。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-weibo-line text-foreground-600"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-wechat-line text-foreground-600"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-tiktok-line text-foreground-600"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-live-line text-foreground-600"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { href: '#about', label: aboutNavTitle },
                { href: '#features', label: featuresNavTitle },
                { href: '#carousel', label: carouselNavTitle },
                { href: '#ranking', label: '热播排行榜' },
                { href: '#topics', label: topicsNavTitle },
                { href: '#cards', label: cardsNavTitle },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {[
                { href: '#faq', label: '常见问题' },
                { href: '#contact', label: '联系我们' },
                { href: '#comments', label: '用户反馈' },
                { href: '#updates', label: '最新动态' },
                { href: '#app', label: '移动客户端' },
                { href: '#media', label: '精彩片花' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              我们与众多优质内容方和技术伙伴保持紧密合作，持续为观众带来更丰富的影视资源和更流畅的观影体验。
            </p>
            <div className="mt-4 space-y-1.5">
              <p className="text-xs text-foreground-400">客服邮箱：contact@aikanyingyuan.com</p>
              <p className="text-xs text-foreground-400">服务时间：每日 9:00 - 24:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 爱看影院 版权所有 | 高清电影在线观看 | 高清电视剧全集免费看
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span className="cursor-pointer hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}